export default __webpack_public_path__ + "static/media/users-active.9b43dada.png";